import { useState, useEffect } from 'react'
import { Button, CircularProgress } from '@mui/material'
import ExportForm from './ExportForm'
import useFinancial from '../../../hooks/useFinancial'
import Modal from '../../Modal'
import { useProject } from '../../../context/project'
import { useGeneral } from '../../../context/general'
import { getDatasetFrequency } from '../../../utils/aggregationUtils'
import { downloadFile } from '../../../utils/tools'
import axios from 'axios'

export default function ExportModal({open, close, dataset, ticker, financialInfo}) {
    const { datasets, privateCompany } = useProject()
    const { setPopupAlert } = useGeneral()
    const { getFinancialNameByValue } = useFinancial(ticker)
    
    const [form, setForm] = useState([])
    const [loading, setLoading] = useState(false)
      
    const updateField = (data, i) => {
        const newForm = [...form]
        newForm[i] = data
        setForm(newForm)
    }

    const submitForm = async () => {
        setLoading(true)
        const formToSend = form.filter(field => field.enable)
        const request = await fetch('/api/export', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formToSend)
        })
        // const request = await axios({
        //     method: 'POST',
        //     url: '/api/export',
        //     data: formToSend,
        // })
        if (request.ok) {
            close()
            const blob = await request.blob()
            const file = window.URL.createObjectURL(blob)
            downloadFile(file, `FE-export-${ticker}.csv`)
            setPopupAlert('success', 'Export Completed. Enjoy the Data')
        } else {
            setPopupAlert('error', 'Could not export data')
        }
        setLoading(false)
        close()
    }

    useEffect(() => {
        if (open) {
            let initialForm = dataset.map(({datasetName, columnName, datasetValue, columnValue}, i) => ({
                name: columnName,
                dataset: { value: datasetValue, name: datasetName },
                column: { value: columnValue, name: columnName },
                group: { value: getDatasetFrequency(datasets, datasetValue) === 'yearly' ? 'yearly': 'quarterly' },
                agg: { value: 'mean' },
                enable: false,
                p_change: false,
                ticker,
                privateCompany,
                i,
            }))
            if (financialInfo) {
                const financialInfoColumn = {
                    value: financialInfo,
                    name: getFinancialNameByValue(financialInfo)
                }
                initialForm = [...initialForm, {
                    name: financialInfoColumn.name,
                    dataset: { value: 'financial_data', name: 'Financial Data'},
                    column: financialInfoColumn,
                    enable: false,
                    ticker,
                    privateCompany,
                    i: initialForm.length,
                    group: { value: 'quarterly' },
                    agg: { value: 'mean' },
                    p_change: false,
                }]
            }
            setForm(initialForm)
        }
        return () => {}
    }, [ dataset, open, ticker, financialInfo, privateCompany ]) // eslint-disable-line

    const invalidForm = !form.some(field => field.enable)

    const buttons = [
        <Button key="cancel" onClick={close}>Cancel</Button>,
        <Button key="export" color="primary" variant="contained" onClick={submitForm} disabled={loading || invalidForm}>
            {loading ? <CircularProgress size="1.5rem"/> : 'Export'}
        </Button>,
    ]

    return (
        <Modal title="Export" open={open} handleClose={close} buttons={buttons}>
            <ExportForm form={form} updateField={updateField} datasets={datasets} ticker={ticker}/>
        </Modal>
    )
}